<template>
  <MButton v-bind="getBindValue" @click="onClick">
    <slot>{{ t('common.export') }}</slot>
  </MButton>
  <MButton v-bind="getBindValue" @click="openExportModal">
    <slot name="exportRecord">{{ t(recordBtnText || 'g.25090028') }}</slot>
  </MButton>
</template>

<script setup lang="ts">
  import { ComponentOptionsMixin, computed, unref } from 'vue';
  import { useAttrs } from '@mts-fe/hooks';
  import { omit, replaceUrl, RequestMethod } from '@mts-fe/utils';
  import { MButton } from '@mts/components/Button';
  import { t } from '@mts/hooks/web/useI18n';
  import { defHttp } from '@mts/utils/http/axios';
  import { getGlobalStore } from '@/store';
  import type { MExportProps } from '..';

  /** 异步导出 */
  defineOptions({
    name: 'AsyncExport',
    extends: MButton as ComponentOptionsMixin,
    inheritAttrs: false,
  });

  const props = defineProps<{ typeCode: string; recordBtnText?: string } & MExportProps>();
  const attrs = useAttrs();
  const getBindValue = computed(() => ({
    ...unref(attrs),
    ...omit(props, ['typeCode', 'path', 'params', 'axiosConfig', 'axiosOptions', 'recordBtnText']),
  }));

  const onClick = async () => {
    const params = typeof props.params == 'function' ? props.params() : props.params;
    const url = params ? replaceUrl(props.path, params) : props.path;
    defHttp
      .request(
        {
          method: RequestMethod.POST,
          ...props.axiosConfig,
          url,
          params: { ...params, typeCode: props.typeCode },
        },
        props.axiosOptions,
      )
      .then(openExportModal)
      .catch((err) => console.error('AsyncExport', err));
  };

  const openExportModal = () => getGlobalStore().updateExportModal(true, props.typeCode);
</script>
